module.exports = __webpack_public_path__ + "img/img_industries4.ed67644b.jpg";